export default __webpack_public_path__ + "static/media/network-banner.25ee9ae0.png";